module.exports = __webpack_public_path__ + "01_long_brown.1c66e98f.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/dad/layer5/01_long_brown.png
// module id = MaKZ
// module chunks = 0